import { Component, input, output } from '@angular/core';
import { DataTableComponent, DataTableColumn, DataTablePageChangedEvent } from '@shared/components/data-table.component';
import { UserResponse } from '../../user.model';
import {ActionMenu} from '@shared/components/action-menu/action-menu';
import { useUserActionMenu } from './user-action-menu.composable';

export type UsersPageChangedEvent = DataTablePageChangedEvent;

@Component({
  selector: 'user-table',
  imports: [DataTableComponent,ActionMenu],
  templateUrl: './user-table.component.html',
  styles: ``,
})
export class UserTable {
  protected readonly columns : DataTableColumn<UserResponse>[]=[
    {
      id: 'name',
      header: 'Name',
      value: (user) => `${user.firstName} ${user.lastName}`.trim(),
      cellClass: 'px-3 py-3 font-medium'
    },
    {
      id:'email', 
      header: 'Email',
      value: (user) => `${user.email}`.trim(), 
    },
    {
      id: 'portal', 
      header: 'Portal', 
      value: (user) => `${user.portal}`.trim(), 
    },
    {
      id: 'userRole', 
      header: 'User role',
      value: (user) => `${user.userRole}`.trim(),
    },
    {
      id: 'client', 
      header: 'Client', 
      value: (user) => `${user.client}`.trim(),
    },
    {
      id: 'status', 
      header: 'Status', 
      value: (user) => `${user.isActive ? 'Active' : 'Inactive'}`.trim(),
    },
  ];

  readonly users = input<UserResponse[]>([]); 
  readonly loading = input(false);
  readonly searchTerm = input('');
  readonly pageNumber = input(1);
  readonly pageSize = input(25);
  readonly totalCount = input(0);
  readonly totalPages = input(0);
  readonly canActivate = input(false);
  readonly canDeactivate = input(false);
  readonly actionUserId = input<string | null>(null);

  readonly refreshed = output<void>();
  readonly searchChanged = output<string>();
  readonly pageChanged = output<UsersPageChangedEvent>();
  readonly toggled = output<UserResponse>();
  readonly actionMenuItems = useUserActionMenu().userActionMenuItems;
  readonly actions: Record<string, any> = {
    'pageChanged': this.pageChanged,
    'toggled': this.toggled,
  };
}
